module.exports = __webpack_public_path__ + "b91d376b8d7646d671cd820950d5f7f1.woff2";